<div class="container-margin">
  <div class="page-caption">
    <h1 style="color: #0074a7" class="page-title" translate>
      components.cookiePolicy.POLÍTICA DE COOKIES
    </h1>
  </div>

  <div class="page-wrapper">
    <div class="page-content">
      <div class="post-1146 page type-page status-publish hentry">
        <div class="entry-content">
          <p class="text-justify" translate>components.cookiePolicy.text2</p>
          <p class="text-justify" translate>components.cookiePolicy.text3</p>
          <p class="text-justify" translate>components.cookiePolicy.text4</p>
          <ul>
            <li class="text-justify" translate>
              components.cookiePolicy.text5
            </li>
            <li class="text-justify" translate>
              components.cookiePolicy.text6
            </li>
            <li class="text-justify" translate>
              components.cookiePolicy.text7
            </li>
            <li class="text-justify" translate>
              components.cookiePolicy.text8
            </li>
            <li class="text-justify" translate>
              components.cookiePolicy.text9
            </li>
          </ul>
          <p class="text-justify" translate>components.cookiePolicy.text10</p>
          <ul>
            <li class="text-justify" translate>
              components.cookiePolicy.text11
            </li>
            <li class="text-justify" translate>
              components.cookiePolicy.text12
            </li>
            <li class="text-justify" translate>
              components.cookiePolicy.text13
            </li>
            <li class="text-justify" translate>
              components.cookiePolicy.text14
            </li>
          </ul>
          <p class="text-justify" translate>
            components.cookiePolicy.Consentimiento para
          </p>
          <p class="text-justify" translate>
            components.cookiePolicy.Para que nuestro sitio web
            <a href="https://cookiefirst.com" target="_blank" translate>
              https://cookiefirst.com
            </a>
            <span translate
              >components.cookiePolicy.denominado CookieFirst</span
            >
          </p>
          <p class="text-justify" translate>
            components.cookiePolicy.Cuando accedes a nuestro sitio web
          </p>
          <p class="text-justify" translate>
            components.cookiePolicy.Acuerdo de procesamiento de datos
          </p>
          <p class="text-justify" translate>
            components.cookiePolicy.Hemos celebrado un acuerdo de procesamiento
          </p>
          <p class="text-justify" translate>
            components.cookiePolicy.Archivos de registro del servidor
          </p>
          <p class="text-justify" translate>
            components.cookiePolicy.Nuestro sitio web y CookieFirst
          </p>
          <ul>
            <li class="text-justify" translate>
              components.cookiePolicy.Tu consentimiento o
            </li>
            <li class="text-justify" translate>
              components.cookiePolicy.Tu dirección IP anónima
            </li>
            <li class="text-justify" translate>
              components.cookiePolicy.Información sobre tu navegador
            </li>
            <li class="text-justify" translate>
              components.cookiePolicy.Información sobre tu dispositivo
            </li>
            <li class="text-justify" translate>
              components.cookiePolicy.La fecha y hora en que
            </li>
            <li class="text-justify" translate>
              components.cookiePolicy.La url de la página web en la
            </li>
            <li class="text-justify" translate>
              components.cookiePolicy.La ubicación aproximada del usuario
            </li>
            <li class="text-justify" translate>
              components.cookiePolicy.Un identificador único
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
